export const statusData = [
  { id: "-2", name: "Blocked", isChecked: false },
  { id: "-1", name: "Restricted", isChecked: false },
  { id: "0", name: "Invited", isChecked: false },
  { id: "1", name: "Active", isChecked: false },
];

export const pageOptions = [
  { id: 5, value: 1, label: 1 },
  { id: 6, value: 2, label: 2 },
  { id: 7, value: 5, label: 5 },
  { id: 1, value: 10, label: 10 },
  { id: 2, value: 25, label: 25 },
  { id: 3, value: 50, label: 50 },
  { id: 4, value: 100, label: 100 },
];
